import React from 'react';

const TechnicalPreview = () => {
  return (
    <section id="tech" className="bg-background py-32 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          <div>
            <span className="font-lexend font-bold text-pacer-start tracking-[0.3em] text-xs uppercase mb-6 block">DATA VISUALIZATION</span>
            <h2 className="font-lexend font-extrabold text-5xl tracking-tighter uppercase italic mb-8">
              SEMÁFORO DE <span className="text-success">ENTRENAMIENTO</span>
            </h2>
            <p className="font-inter text-[#888] mb-12 leading-relaxed max-w-md">
              Nuestra interfaz propietaria traduce miles de puntos de datos en una señal simple y accionable. No te limites a correr; corre de manera inteligente.
            </p>
            
            <div className="space-y-6">
              {[
                { label: 'Óptimo', color: 'bg-lime', value: 85 },
                { label: 'Fatiga Moderada', color: 'bg-yellow-400', value: 45 },
                { label: 'Riesgo de Lesión', color: 'bg-red-500', value: 12 },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-6">
                  <div className={`w-3 h-3 rounded-full ${item.color} shadow-[0_0_15px_rgba(163,250,0,0.3)]`}></div>
                  <span className="font-lexend font-bold text-sm tracking-widest uppercase flex-1">{item.label}</span>
                  <div className="w-48 h-1 bg-surface rounded-full overflow-hidden">
                    <div 
                      className={`h-full ${item.color}`} 
                      style={{ width: `${item.value}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative group">
            <div className="absolute -inset-4 bg-gradient-to-tr from-pacer-start/20 to-lime/20 rounded-lg blur-2xl opacity-50 group-hover:opacity-100 transition-opacity"></div>
            <div className="relative bg-[#1a1a1a] rounded-sm p-8 shadow-2xl overflow-hidden">
              {/* Simulated UI Graph */}
              <div className="flex items-end gap-2 h-64 mb-8">
                {[40, 60, 45, 90, 85, 95, 80, 70, 60, 85, 100, 90].map((h, i) => (
                  <div 
                    key={i} 
                    className={`flex-1 transition-all duration-1000 delay-${i * 100} ${h >= 80 ? 'bg-lime' : 'bg-surface'}`}
                    style={{ height: `${h}%` }}
                  ></div>
                ))}
              </div>
              <div className="flex justify-between items-center bg-background p-6 rounded-sm">
                <div>
                  <div className="text-[#666] text-[10px] uppercase tracking-widest mb-1">Status Actual</div>
                  <div className="font-lexend font-extrabold text-2xl text-lime uppercase italic">RENDIMIENTO ÓPTIMO</div>
                </div>
                <div className="text-right">
                  <div className="text-[#666] text-[10px] uppercase tracking-widest mb-1">Cadencia Media</div>
                  <div className="font-lexend font-extrabold text-2xl text-white italic">182 SPM</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnicalPreview;
